var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_8_245",
    "data-name": "Component 8 \\u2013 245",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24198",
    "data-name": "Group 24198",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M277.747,409.443H285",
    transform: "translate(-267 -392)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M276.78,392.8a2.245,2.245,0,0,1,3.116-.3l1.733,1.347a2.142,2.142,0,0,1,.72,2.984c-.034.054-9.537,11.941-9.537,11.941a1.7,1.7,0,0,1-1.309.633l-3.639.046-.82-3.471a1.629,1.629,0,0,1,.316-1.395Z",
    transform: "translate(-267 -392)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M275.021,395l5.452,4.187",
    transform: "translate(-267 -392)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8528",
    "data-name": "Rectangle 8528",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit4);
export default __webpack_public_path__ + "static/media/edit-4.a6fed43a.svg";
export { ForwardRef as ReactComponent };